import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import { LotsMapEs } from './map_es.jsx';
import { LotsMapEn } from './map_en.jsx';

export const LotsMap = (props) => {
	const {
		i18n: { language },
	} = useTranslation();

	let LotsMap = LotsMapEn;
	if (language === 'es') LotsMap = LotsMapEs;

	return (
		<LotsMap {...props} />
	);
};
